import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthorizationService } from "./authorization.service";
import { from, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class TokenInterceptorService implements HttpInterceptor {
  constructor(private authorizationService: AuthorizationService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handleAccessToken(req, next));
  }

  async handleAccessToken(req: HttpRequest<any>, next: HttpHandler) {
    const baseUrl = this.getBaseUrl(req.url);
    let audience = "";

    if (baseUrl === this.getBaseUrl(environment.authZApiRoot.url)) {
      audience = environment.authZApiRoot.audience;
    }

    if (baseUrl === this.getBaseUrl(environment.auditApiRoot.url)) {
      audience = environment.auditApiRoot.audience;
    }

    if (baseUrl === this.getBaseUrl(environment.claimApiRoot.url)) {
      audience = environment.claimApiRoot.audience;
    }

    if (baseUrl === this.getBaseUrl(environment.faxApiRoot.url)) {
      audience = environment.faxApiRoot.audience;
    }

    if (baseUrl === this.getBaseUrl(environment.imageApiRoot.url)) {
      audience = environment.imageApiRoot.audience;
    }

    if (baseUrl === this.getBaseUrl(environment.lookerAdminRoot.url)) {
      audience = environment.lookerAdminRoot.audience;
    }

    var accessToken = "";

    if (this.authorizationService.HealthcareTopBar) {
      accessToken =
        await this.authorizationService.HealthcareTopBar.getAccessToken(
          audience
        );
    }

    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return next.handle(req).toPromise();
  }

  private getBaseUrl(url: string): string {
    try {
      const urlObj = new URL(url);
      return `${urlObj.protocol}//${urlObj.host}`;
    } catch (e) {
      console.error("getBaseUrl failed for:", url);
      throw e;
    }
  }
}
